import makeStyles from "@mui/styles/makeStyles";
import { lighten } from "@mui/material/styles";
import { ThemeColor } from "../theme/createTheme";

export const useButtonStyles = makeStyles({
  root: (props: { noPadding?: boolean; justifyContent?: "space-between" }) => ({
    position: "relative",
    minWidth: 40,
    height: 40,
    padding: props.noPadding ? 0 : "0 20px",
    textTransform: "initial",
    fontWeight: "bold",
    fontSize: 14,
    lineHeight: "14px",
    borderRadius: 4,
    "& > span": {
      display: "flex",
      justifyContent: props.justifyContent,
      position: "relative",
    },
  }),
  containedSizeSmall: (props: { noPadding?: boolean }) => ({
    minWidth: 36,
    height: 36,
    fontSize: 12,
    padding: props.noPadding ? 0 : "0 12px",
  }),
  outlinedSizeSmall: (props: { noPadding?: boolean }) => ({
    minWidth: 36,
    height: 36,
    fontSize: 12,
    padding: props.noPadding ? 0 : "0 12px",
  }),
  textSizeSmall: (props: { noPadding?: boolean }) => ({
    minWidth: 36,
    height: 36,
    fontSize: 12,
    padding: props.noPadding ? 0 : "0 12px",
  }),
});

export const useStyles = makeStyles((theme) => ({
  contained: (props: { color: ThemeColor }) => ({
    background: theme.palette[props.color].main,
    color: theme.palette[props.color].contrastText,
    "&:hover": {
      background: theme.palette[props.color].dark,
    },
    "&:focus": {
      boxShadow: `0 0 0 4px ${lighten(theme.palette[props.color].main, 0.8)}`,
    },
    "&[aria-disabled=true]": {
      color: `${theme.palette.common.white} !important`,
      background: `${theme.palette.grey[500]} !important`,
      cursor: "default",
      "&:focus": {
        boxShadow: `0 0 0 4px ${theme.palette.grey[200]}`,
      },
    },
  }),
  outlined: (props: { color: ThemeColor }) => ({
    borderWidth: 2,
    borderColor: theme.palette[props.color].main,
    color: theme.palette[props.color].main,
    "&:hover": {
      // v5's outlined hover sets the `border` shorthand, resetting width to 1px.
      borderWidth: 2,
      borderColor: theme.palette[props.color].dark,
      color: theme.palette[props.color].dark,
      background: "transparent",
    },
    "&:focus": {
      boxShadow: `0 0 0 4px ${lighten(theme.palette[props.color].main, 0.8)}`,
    },
    "&[aria-disabled=true]": {
      borderWidth: 2,
      color: theme.palette.grey[500],
      borderColor: theme.palette.grey[500],
      cursor: "default",
      "&:focus": {
        boxShadow: `0 0 0 4px ${theme.palette.grey[200]}`,
      },
    },
  }),
  text: (props: { color: ThemeColor }) => ({
    minWidth: "auto",
    height: "auto",
    color: theme.palette[props.color].main,
    fontWeight: "normal",
    "&:hover": {
      color: theme.palette[props.color].dark,
      background: "transparent",
    },
    "&:focus": {
      "&::before": {
        content: "''",
        position: "absolute",
        inset: "-4px",
        // TODO: find alternate
        // background: alpha(theme.palette[props.color].main, 0.1),
        borderRadius: 8,
      },
    },
    "&[aria-disabled=true]": {
      color: theme.palette.grey[700],
      cursor: "default",
      "&:focus": {
        "&::before": {
          background: theme.palette.grey[100],
        },
      },
    },
    "& .MuiButton-startIcon": {
      marginRight: 4,
    },
    "& .MuiButton-endIcon": {
      marginLeft: 4,
    },
  }),
  noWrap: () => ({
    whiteSpace: "nowrap",
  }),
  loading: () => ({
    margin: "0 12px 0 -8px",
  }),
}));
